(function () {
  var STYLE_ID = 'surjupe-variant-pill-split-styles';
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.ma-variant-pill--split {',
      '  flex-direction: column;',
      '  white-space: normal;',
      '  line-height: 1.25;',
      '  padding: 10px 2px;',
      '  min-height: 58px;',
      '  min-width: 0;',
      '}',
      '.ma-variant-pill__main {',
      '  display: block;',
      '  font-size: 11px;',
      '  letter-spacing: 0.5px;',
      '  text-align: center;',
      '  white-space: nowrap;',
      '}',
      '.ma-variant-pill__sub {',
      '  display: block;',
      '  font-size: 9px;',
      '  letter-spacing: 0.3px;',
      '  color: #9a948e;',
      '  margin-top: 3px;',
      '  font-weight: 400;',
      '  text-align: center;',
      '  white-space: nowrap;',
      '}',
      '.ma-variant-pill--active .ma-variant-pill__sub {',
      '  color: #6b6560;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function fitText(el, available, defaultSize, minSize) {
    var size = defaultSize;
    el.style.fontSize = size + 'px';
    while (el.scrollWidth > available && size > minSize) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }

  function fitAllSubs(root) {
    var scope = root || document;
    scope.querySelectorAll('.ma-variant-pill--split').forEach(function (pill) {
      var style = window.getComputedStyle(pill);
      var padL = parseFloat(style.paddingLeft) || 0;
      var padR = parseFloat(style.paddingRight) || 0;
      var available = pill.clientWidth - padL - padR;
      if (available <= 0) return;
      var mainEl = pill.querySelector('.ma-variant-pill__main');
      var subEl = pill.querySelector('.ma-variant-pill__sub');
      if (mainEl) fitText(mainEl, available, 11, 8);
      if (subEl) fitText(subEl, available, 9, 6);
    });
  }

  function splitPills() {
    injectStyles();
    var pills = document.querySelectorAll('.ma-variant-pill');
    pills.forEach(function (pill) {
      if (pill.dataset.splitDone === '1') return;
      var raw = (pill.textContent || '').trim();
      if (raw.indexOf(':') === -1) {
        pill.dataset.splitDone = '1';
        return;
      }
      var idx = raw.indexOf(':');
      var main = raw.slice(0, idx).trim();
      var sub = raw.slice(idx + 1).trim();
      var mainEl = document.createElement('span');
      mainEl.className = 'ma-variant-pill__main';
      mainEl.textContent = main.replace(/\s+/g, '\u00A0');
      var subEl = document.createElement('span');
      subEl.className = 'ma-variant-pill__sub';
      subEl.textContent = sub;
      pill.innerHTML = '';
      pill.appendChild(mainEl);
      pill.appendChild(subEl);
      pill.classList.add('ma-variant-pill--split');
      pill.dataset.splitDone = '1';
    });
    requestAnimationFrame(function () { fitAllSubs(); });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { fitAllSubs(); }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitPills);
  } else {
    splitPills();
  }
  document.addEventListener('shopify:section:load', splitPills);
})();
